// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"343":"d9cba84c","746":"87fbd641","766":"f9b1e6b7"}[chunkId] + ".chunk.css";
};